// extracted by mini-css-extract-plugin
export default {"error":"Form_error__JN-Kt","regex-message":"Form_regex-message__c5STi"};